import { render, staticRenderFns } from "./AttributesListsDetail.vue?vue&type=template&id=44ac16da"
import script from "./AttributesListsDetail.vue?vue&type=script&lang=js"
export * from "./AttributesListsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports